import SuggestionTable from "./SuggestionTable";

export default SuggestionTable;
export { SuggestionTable };
